// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-links ul li a {
  font-size: var(--font-size-regular);
  font-weight: var(--font-medium);
  color: var(--text-gray-light-2);
  margin-bottom: 10px;
  list-style: none;
  text-decoration: none;
}

.footer-links ul li {
  border: none;
  line-height: 1.7;
}

.footer-logo {
  width: 400px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.footer-section {
  padding: 70px 0px 20px 0px;
}

.vertical-social-links {
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-top: 50px;
}

.vertical-social-links li {
  border: none;
}

.border-primary-bottom {
  border-bottom: 3px solid var(--text-primary);
}

.copyright-text {
  /* font-family: var(--font-codec-cold); */
  font-size: var(--font-size-xsmall);
  font-weight: var(--font-regular);
  color: var(--text-black);
}

@media (min-width: 768px) {
  .btn-explore-contact {
    left: -26px;
  }
}


@media (min-width: 768px) and (max-width: 1024px) {
  .footer-links ul li {
    text-align: center;
  }

  .footer-logo {
    padding-bottom: 50px;
  }

  .copyright-text {
    margin-top: 20px;
  }

}

@media (max-width: 767px) {

  .footer-logo {
    width: 212px;
    padding-bottom: 15px;
  }

  .footer-section {
    padding: 50px 0px 20px 0px;
  }

  .footer-links ul li a {
    font-size: var(--font-size-small);
  }

  .footer-links ul li {
    border: none;
    padding: 5px 0;
  }

  .copyright-text {
    font-size: var(--font-size-small);
    padding-top: 15px;
  }

  .footer-links ul li {
    text-align: center;
  }

  .vertical-social-links {
    padding-left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding-top: 10px;
  }

  .vertical-social-links li a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    transition: transform 0.2s;
  }

  .adp-mobile-footer-links a {
    white-space: nowrap;
  }
}

.btn-explore-contact {
  background: linear-gradient(90deg, #6318C6 0%, #a44893 50%, #e2b31c 100%);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  border: none;
  border-radius: 30px;
  padding: 9px 26px;
  display: inline-block;
  box-shadow: 0 8px 20px rgba(99, 24, 198, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;
  font-family: var(--font-inter-semibold);
  position: relative;
}

.btn-explore-contact:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px rgba(99, 24, 198, 0.3);
  color: #ffffff;
}


@media (min-width: 1025px) and (max-width: 1280px) {
  .footer-links ul li a {
    font-size: var(--font-size-18);
  }
}

/* New Footer Styles */
.footer-section-new {
  padding: 45px 0px 30px 0px;
  border-top: 3px solid #6318C60D;
  /* background: linear-gradient(90deg,
      #F8FAFC 0%,
      #FAF5FF 20%,
      #FFFBEB 30%); */
  background: linear-gradient(90deg, rgba(99, 24, 198, 0.2) 0%, rgba(242, 204, 0, 0.3) 100%);
}

.footer-heading {
  color: #0F172B;
  font-size: 14px;
  font-family: var(--font-montserrat-semibold);
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.footer-new-links li a,
.account-text-link,
.copyright-text-new {
  color: #45556C;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}

.bottom-links a {
  color: #45556C;
  font-size: 14px;
  font-family: var(--font-montserrat-regular);
  font-weight: 400;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-new-links li {
  margin-bottom: 12px;
}

.footer-new-links li a:hover,
.account-text-link:hover,
.bottom-links a:hover {
  color: #0F172B;
}

.account-text-link {
  display: block;
}

.contact-demo-btn {
  background: linear-gradient(90deg, #8A2BE2 0%, #EAB308 100%);
  color: #fff;
  border-radius: 30px;
  padding: 8px 24px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
  border: none;
  text-align: center;
  transition: opacity 0.2s ease;
}

.contact-demo-btn:hover {
  color: #fff;
  opacity: 0.9;
}

.social-icons-wrapper a {
  width: 40px;
  height: 40px;
  transition: transform 0.2s;
  background-color: white;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 1px 2px -1px #0000001A;
  box-shadow: 0px 1px 3px 0px #0000001A;
  border: 1px solid #E2E8F0;

}

.social-icons-wrapper img {
  width: 20px;

}

.social-icons-wrapper a:hover img {
  transform: translateY(-2px);
}

.download-badge {
  height: 70px;
  width: auto;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}

.footer-bottom-bar {
  border-top: 1px solid #E2E8F099;
  background-color: rgba(255, 255, 255, 0.4);
}

@media (max-width: 767px) {
  .footer-section-new {
    padding: 37px 0px 30px 0px;
  }

  .bottom-links {
    margin-bottom: 10px;
  }

  .copyright-text-new,
  .bottom-links a {
    font-size: 13px;
  }

  .footer-heading {
    margin-bottom: 10px;
  }

  .footer-new-links li {
    margin-bottom: 10px;
  }

  .footer-col {
    margin-bottom: 30px;
    text-align: center;
  }

  .social-icons-wrapper,
  .bottom-links,
  .account-links-wrap {
    justify-content: center !important;
    align-items: center !important;
  }

  .footer-new-links {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;;AAGA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,yEAAyE;EACzE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,cAAc;AAChB;;;AAGA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B;;;qBAGmB;EACnB,0FAA0F;AAC5F;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,qCAAqC;EACrC,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;;AAEb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;IAGE,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".footer-links ul li a {\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-medium);\n  color: var(--text-gray-light-2);\n  margin-bottom: 10px;\n  list-style: none;\n  text-decoration: none;\n}\n\n.footer-links ul li {\n  border: none;\n  line-height: 1.7;\n}\n\n.footer-logo {\n  width: 400px;\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.footer-section {\n  padding: 70px 0px 20px 0px;\n}\n\n.vertical-social-links {\n  padding-left: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  padding-top: 50px;\n}\n\n.vertical-social-links li {\n  border: none;\n}\n\n.border-primary-bottom {\n  border-bottom: 3px solid var(--text-primary);\n}\n\n.copyright-text {\n  /* font-family: var(--font-codec-cold); */\n  font-size: var(--font-size-xsmall);\n  font-weight: var(--font-regular);\n  color: var(--text-black);\n}\n\n@media (min-width: 768px) {\n  .btn-explore-contact {\n    left: -26px;\n  }\n}\n\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .footer-links ul li {\n    text-align: center;\n  }\n\n  .footer-logo {\n    padding-bottom: 50px;\n  }\n\n  .copyright-text {\n    margin-top: 20px;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .footer-logo {\n    width: 212px;\n    padding-bottom: 15px;\n  }\n\n  .footer-section {\n    padding: 50px 0px 20px 0px;\n  }\n\n  .footer-links ul li a {\n    font-size: var(--font-size-small);\n  }\n\n  .footer-links ul li {\n    border: none;\n    padding: 5px 0;\n  }\n\n  .copyright-text {\n    font-size: var(--font-size-small);\n    padding-top: 15px;\n  }\n\n  .footer-links ul li {\n    text-align: center;\n  }\n\n  .vertical-social-links {\n    padding-left: 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding-top: 10px;\n  }\n\n  .vertical-social-links li a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 8px;\n    transition: transform 0.2s;\n  }\n\n  .adp-mobile-footer-links a {\n    white-space: nowrap;\n  }\n}\n\n.btn-explore-contact {\n  background: linear-gradient(90deg, #6318C6 0%, #a44893 50%, #e2b31c 100%);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  border: none;\n  border-radius: 30px;\n  padding: 9px 26px;\n  display: inline-block;\n  box-shadow: 0 8px 20px rgba(99, 24, 198, 0.2);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-decoration: none;\n  font-family: var(--font-inter-semibold);\n  position: relative;\n}\n\n.btn-explore-contact:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 25px rgba(99, 24, 198, 0.3);\n  color: #ffffff;\n}\n\n\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .footer-links ul li a {\n    font-size: var(--font-size-18);\n  }\n}\n\n/* New Footer Styles */\n.footer-section-new {\n  padding: 45px 0px 30px 0px;\n  border-top: 3px solid #6318C60D;\n  /* background: linear-gradient(90deg,\n      #F8FAFC 0%,\n      #FAF5FF 20%,\n      #FFFBEB 30%); */\n  background: linear-gradient(90deg, rgba(99, 24, 198, 0.2) 0%, rgba(242, 204, 0, 0.3) 100%);\n}\n\n.footer-heading {\n  color: #0F172B;\n  font-size: 14px;\n  font-family: var(--font-montserrat-semibold);\n  font-weight: 700;\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n\n.footer-new-links li a,\n.account-text-link,\n.copyright-text-new {\n  color: #45556C;\n  font-size: 14px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.bottom-links a {\n  color: #45556C;\n  font-size: 14px;\n  font-family: var(--font-montserrat-regular);\n  font-weight: 400;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.footer-new-links li {\n  margin-bottom: 12px;\n}\n\n.footer-new-links li a:hover,\n.account-text-link:hover,\n.bottom-links a:hover {\n  color: #0F172B;\n}\n\n.account-text-link {\n  display: block;\n}\n\n.contact-demo-btn {\n  background: linear-gradient(90deg, #8A2BE2 0%, #EAB308 100%);\n  color: #fff;\n  border-radius: 30px;\n  padding: 8px 24px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  text-decoration: none;\n  display: inline-block;\n  border: none;\n  text-align: center;\n  transition: opacity 0.2s ease;\n}\n\n.contact-demo-btn:hover {\n  color: #fff;\n  opacity: 0.9;\n}\n\n.social-icons-wrapper a {\n  width: 40px;\n  height: 40px;\n  transition: transform 0.2s;\n  background-color: white;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 1px 2px -1px #0000001A;\n  box-shadow: 0px 1px 3px 0px #0000001A;\n  border: 1px solid #E2E8F0;\n\n}\n\n.social-icons-wrapper img {\n  width: 20px;\n\n}\n\n.social-icons-wrapper a:hover img {\n  transform: translateY(-2px);\n}\n\n.download-badge {\n  height: 70px;\n  width: auto;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n}\n\n.footer-bottom-bar {\n  border-top: 1px solid #E2E8F099;\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n@media (max-width: 767px) {\n  .footer-section-new {\n    padding: 37px 0px 30px 0px;\n  }\n\n  .bottom-links {\n    margin-bottom: 10px;\n  }\n\n  .copyright-text-new,\n  .bottom-links a {\n    font-size: 13px;\n  }\n\n  .footer-heading {\n    margin-bottom: 10px;\n  }\n\n  .footer-new-links li {\n    margin-bottom: 10px;\n  }\n\n  .footer-col {\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .social-icons-wrapper,\n  .bottom-links,\n  .account-links-wrap {\n    justify-content: center !important;\n    align-items: center !important;\n  }\n\n  .footer-new-links {\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
